import React from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "@/context/DataContext";

export default function StoryPage() {
  const { settings } = useData();
  const navigate = useNavigate();
  return (
    <div>
      <section className="relative py-24 tropical-grain">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-amber-400">Our Story</span>
          <h1 className="font-display font-black uppercase tracking-tight text-4xl sm:text-6xl mt-3">{settings?.story_title || "The Story Behind Sir. King Kitchen"}</h1>
        </div>
      </section>
      <section className="relative pb-20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(16,84,54,0.5),transparent_55%),radial-gradient(circle_at_90%_90%,rgba(120,53,15,0.3),transparent_55%)] pointer-events-none" />
        <div className="relative max-w-5xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <img src={settings?.chef_image} alt="Sir. King Kitchen chef and founder" className="rounded-3xl w-full max-h-[560px] aspect-[4/5] object-cover object-center border border-amber-500/30 shadow-2xl lg:sticky lg:top-24" />
        <div>
          <div className="text-[#FDFBF7]/80 space-y-5 leading-relaxed whitespace-pre-line text-lg">{settings?.story_body}</div>
          <div className="grid grid-cols-2 gap-3 mt-8">
            {["Family", "Culture", "Flavor", "Community"].map((t) => (
              <div key={t} className="rounded-2xl bg-[#181D1A] border border-amber-500/30 p-5 text-center font-display font-black uppercase tracking-wide text-amber-300">{t}</div>
            ))}
          </div>
          <button onClick={() => navigate("/catering")} className="mt-8 px-7 py-4 rounded-full bg-amber-400 text-[#0A2818] font-display font-black uppercase tracking-wide active:scale-95 transition-transform">Book Us For Your Event</button>
        </div>
        </div>
      </section>
    </div>
  );
}
